import React, { Component } from 'react';
import { Media } from 'react-bootstrap';
import { Avatar } from '../../ui';
import { mixinsClassName } from '../../utils';

export default class extends Component {
    render() {
        const { data, onClick, onDoubleClick } = this.props;
        const className = mixinsClassName(
            data.is_active ? "active" : "",
            this.props,
            "media-odd"
        );

        return (
            <Media className={className} 
                   onClick={onClick&&onClick.bind(this, data, "user")} 
                   onDoubleClick={onDoubleClick&&onDoubleClick.bind(this, data, "user")}
                   title="【双击】可进入会话">
              <Media.Left>
                <Avatar src={data.avatar} text={data.nick_name} className={data.status}/>
              </Media.Left>
              <Media.Body>
                <Media.Heading>{data.nick_name}</Media.Heading>
              </Media.Body>
            </Media>
        );
    }
}


// WEBPACK FOOTER //
// ./src/user/item/index.js